import { IEndpointData } from 'SharedDir/declarations/shared';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const statisticsUrl = `${SERVER_API}/statistics`;

export default {
  LOGINS: {
    method: 'GET',
    url: `${statisticsUrl}/logins`,
  } as IEndpointData,
  REGISTRATION: {
    method: 'GET',
    url: `${statisticsUrl}/registration`,
  } as IEndpointData,
};
